import APosterLogo from './a-poster-logo';

export default APosterLogo;